import { msg } from 'gt-react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { Route as pathlessAuthenticatedRoute } from '../route';

const DocumentsPage = lazyRouteComponent(() => import('./DocumentsPage'));

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/documents',
  staticData: {
    app: {
      access: {},
    },
  },
  component: DocumentsPage,
  loader: () => ({
    crumb: msg('Documents', { context: 'page breadcrumb' }),
  }),
});
